import { useContext } from "react";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";

export function TSwitch(props: { NS?, DF, IN?}) {
   const { hasAccessToFeature } = useContext(ApplicationStateContext)
   if (hasAccessToFeature(Feature.ThemeNewSec) && props.NS) {
      return props.NS
   }
   return props.DF
}